import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { queryClient } from '@/lib/query-client';
import { router } from '@/router';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';
import { ToastProvider } from '@/components/feedback/Toaster';
import { NieuweVersieMelding } from '@/components/feedback/NieuweVersieMelding';
import { useSessionRestore } from '@/features/auth/hooks/useSessionRestore';
import '@/i18n/config';

// Theme and font-scale are initialized in public/theme-init.js (a classic script in the index.html
// head) to prevent flash of wrong theme before React loads.

function AppContent() {
  const { isLoading } = useSessionRestore();

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center"
        style={{ backgroundColor: 'var(--background)' }}
      >
        <div
          className="flex h-10 w-10 items-center justify-center rounded-xl text-sm font-bold text-white animate-pulse"
          style={{ backgroundColor: 'var(--primary)' }}
        >
          X
        </div>
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <AppContent />
          {/* Buiten de schermindeling, zodat ook het inlogscherm de melding krijgt. */}
          <NieuweVersieMelding />
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
